<template>
  <div class="card-modal-body d-flex flex-column px-md row-gap-md align-items-center justify-content-center">
    <h4 class="text-center text-capitalize color-plum mb-0">
      {{ title }}
    </h4>
    <div
      v-if="$slots.text || text"
      class="d-flex flex-column text-center gap-md">
      <slot
        v-if="$slots.text"
        name="text"/>
      <template v-else-if="Array.isArray(text)">
        <p
          v-for="(text, index) in text"
          :key="`text-${index}`">
          {{ text }}
        </p>
      </template>
      <p v-else>
        {{ text }}
      </p>
    </div>
    <div
      v-if="$slots.default || imageUrl"
      :class="[
        'card-modal-content',
        'd-flex flex-column align-items-center', // Necessary for Safari to properly center content.
        { 'flex-md-grow-1': imageUrl || $slots.default }
      ]">
      <CardModalImage
        v-if="imageUrl"
        :src="imageUrl"
        :alt="title"/>
      <slot/>
    </div>
  </div>
</template>

<script setup>
import CardModalImage from '@/components/modals/CardModalImage.vue'

defineProps({
  title: {
    type: String,
    required: true
  },
  text: {
    type: [String, Array],
    default: null
  },
  imageUrl: {
    type: String,
    default: null
  }
})
</script>

<style lang="scss" scoped>
.card-modal-body {
  user-select: none;

  &, .card-modal-content {
    min-height: 0;
    min-width: 0;
  }
}
</style>
